module.exports = __webpack_public_path__ + "img/detalle-14.d34fbffc.png";